/**
 * Created by mslobozeanu on 6/19/2015.
 */


TS.ns('TS.widget');

(function () {
    'use strict';

    var baseClass = 'grid-cell',
        iconCheckedClass = 'fa fa-check-square-o',
        iconUncheckedClass = 'fa fa-square-o';

    var headerClasses = {
        date: 'align-right',
        time: 'align-right',
        numeric: 'align-right',
        bool: 'align-center'
    };

    var classes = {
        date: 'align-right',
        time: 'align-right',
        numeric: 'align-right',
        radio: 'radio-cell',
        bool: 'align-center checkbox-cell',

        readonly: {
            bool: 'checkbox-cell-read-only'
        }
    };

    var templates = {
        bool: function (value) {
            return '<i class=\"' + (!!value ? iconCheckedClass : iconUncheckedClass) + '\"></i>';
        },

        default: function (value) {
            var column = this,
                strValue;
            if (!value && (value != 0))
                value = '';

            if (column.format) {
                strValue = kendo.toString(value, column.format);
            } else {
                if (typeof value == 'string') {
                    strValue = value;
                } else {
                    strValue = String(value);
                }
            }

            // CP 2040225 - HTML encode value; strings such as <\/script><script>evil()<\/script> break the rendering
            strValue = kendo.htmlEncode(strValue);
            return '<span title=\"' + strValue + '\">' + strValue + '</span>';
        }
    };

    TS.UI.ColumnTemplates = {

        class: function (model) {
            var column = this,
                cellClass;

            cellClass = classes[column.type] || '';
            if (this.editable === false) {
                cellClass += ' ' + (classes.readonly[column.type] || '');
            }
            return cellClass;
        },

        template: function () {
            return function (model) {
                var column = this;

                var value = ko.unwrap(model[column.field]),
                    template = templates[column.type] || templates.default,
                    cellContent = template.call(column, value),
                    cellClass = baseClass + ' ' + (TS.UI.ColumnTemplates.class.call(column, model) || '');

                if(column.expandable === true){
                    return '<div class="' + cellClass + '" style="display:inline-block">' + cellContent + '</div>';
                }
                return '<div class="' + cellClass + '">' + cellContent + '</div>';
            }
        },

        headerClass: function (column) {
            return headerClasses[column.type] || '';
        },

        headerAttributes: function (column) {
            var headerClass = TS.UI.ColumnTemplates.headerClass(column);
            if (headerClass) {
                return {
                    "class": headerClass
                };
            }
        }
    }
})();